export enum AlloyResult {
  Success = "success",
  Partial = "partial",
  Fail = "fail"
}

